import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.trim.js";
import { MOBILE_MIN_HEIGHT_BREAKPOINTS } from "@faire/help-center-utils/consts/MOBILE_MIN_HEIGHT_BREAKPOINTS";
import { MOBILE_MIN_WIDTH_BREAKPOINTS } from "@faire/help-center-utils/consts/MOBILE_MIN_WIDTH_BREAKPOINTS";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
export var buildShortenVersion = function buildShortenVersion(text, maxWordCount) {
  if (text.trim().length === 0) {
    return "";
  }
  return text.split(" ").slice(0, maxWordCount).join(" ").concat("...");
};
export var getMaxWordCountForInstantAnswerExplanation = function getMaxWordCountForInstantAnswerExplanation(hasArticles) {
  var width = getWindowOrThrow().innerWidth;
  var height = getWindowOrThrow().innerHeight;
  if (width <= MOBILE_MIN_WIDTH_BREAKPOINTS.SMALL) {
    if (height <= MOBILE_MIN_HEIGHT_BREAKPOINTS.SHORT) {
      return hasArticles ? 18 : 30;
    }
    return hasArticles ? 25 : 60;
  }
  if (width < MOBILE_MIN_WIDTH_BREAKPOINTS.MEDIUM) {
    return hasArticles ? 30 : 90;
  }
  return hasArticles ? 95 : 190;
};